import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ConditionalRendering } from '@components/common/conditional-rendering';


const HouseholdEligibilityGroup = ({ configs, isMNFullStack, group }) => {
    const {
        members,
        statuses,
        isBhpEligibleDetermined,
        isMedicaidDetermined,
    } = group;

    return (
        <div className="grid-row household-eligibility-group">
            <ul className="tablet:grid-col-6 household-eligibility-group__members pr-3">
                {
                    members.map(member => (
                        <li key={member.id}>
                            <span>{member.name}</span>
                            <ul className="household-eligibility-group__indicators text-green">
                                {member.indicators.map((indicator, ind) => (
                                    <li key={ind} className="household-eligibility-group__indicators_item">
                                        {indicator}
                                    </li>
                                ))}
                            </ul>
                        </li>
                    ))
                }
            </ul>
            <ul className="tablet:grid-col-6 household-eligibility-group__statuses pr-3">
                {statuses.map((status, index) => status && (
                    <li key={index}>
                        {status}
                    </li>
                )
                )}
                <ConditionalRendering isTrue={isMNFullStack}>
                    <ConditionalRendering isTrue={isMedicaidDetermined}>
                        <li key="household_section.public_program.medicaid">
                            <FormattedMessage
                                id="household_section.public_program.medicaid"
                                tagName="p"
                                values={{
                                    a: chunks => (
                                        <a
                                            href={configs.externalEndpoints.MN_LINKS.TRIBAL_AGENCY_LINK}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {chunks}
                                        </a>
                                    ),
                                }}
                            />
                        </li>
                    </ConditionalRendering>
                    <ConditionalRendering isTrue={isBhpEligibleDetermined}>
                        <li key="household_section.public_program.bhp">
                            <FormattedMessage id="household_section.public_program.bhp" tagName="p"/>
                        </li>
                    </ConditionalRendering>
                </ConditionalRendering>
            </ul>
        </div>
    );
};

const HouseholdEligibilityGroups = ({ groups, configs, isMNFullStack }) => {

    return (
        <div className="tablet:grid-col-9">
            {
                Array.isArray(groups) && groups.map((group, index) => {
                    if (group.members && group.members.length > 0) {
                        return (
                            <HouseholdEligibilityGroup
                                group={group}
                                key={index}
                                configs={configs}
                                isMNFullStack={isMNFullStack}
                            />
                        );
                    }
                })
            }
        </div>
    );
};

export default HouseholdEligibilityGroups;